import React, { useEffect, useState } from "react"
import { Box } from "@mui/material"

import AppDialog, { AppDialogFooter, AppDialogHeader } from "@components/@base/Dialog"
import AppNewsFrame from "./Frame"
import { formatDay } from "./@services/dates"


// Width of the popup; the editor's preview uses it too, so text wraps exactly as it will
export const NEWS_DIALOG_WIDTH = 720

// The header an announcement is read under: navy like the support chat, the megaphone, the title and
// its day. The editor's preview uses this very header, so composing one and reading one cannot drift.
export function AppNewsDialogHeader({ title, date, onClose }) {
	return <AppDialogHeader tone="navy" icon="bullhorn" title={title} subtitle={formatDay(date)} onClose={onClose}/>
}

// The dialog an announcement is read in, from the popup and from the News list alike. Header and
// footer stay put; a long body scrolls between them, never a dialog taller than the window.
// It loads the body hidden (`keepMounted`) and only shows once the frame has measured it, so it opens
// at its final size instead of growing in front of the user. `id` changes the announcement shown;
// `children` go under the body (the popup's position dots).
export default function AppNewsDialog({ open, onClose, id, title, date, body, footer, children }) {
	const [ready, setReady] = useState(false)
	// the next announcement starts at the height of the last one, not at the frame's 200 px
	const [lastHeight, setLastHeight] = useState(200)

	useEffect(() => { if (!open) setReady(false) }, [open])

	if (!open) return null

	return <AppDialog
		open={ready}
		keepMounted
		onClose={onClose}
		maxWidth={false}
		paperSx={{ width: NEWS_DIALOG_WIDTH, maxWidth: 'calc(100% - 64px)', display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - 64px)' }}
	>
		<AppNewsDialogHeader title={title} date={date} onClose={onClose}/>
		<Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
			<AppNewsFrame
				key={id}
				html={body}
				title={title}
				height={lastHeight}
				onReady={height => {
					if (height) setLastHeight(height)
					setReady(true)
				}}
			/>
			{children}
		</Box>
		<AppDialogFooter>{footer}</AppDialogFooter>
	</AppDialog>
}
